import { useRestPostQuery } from 'utils/hooks/api';
import { pick } from 'utils/arrayHelpers';
import { LIST_FIELD_FACETS } from 'api/ListsApi';

import { useUserAndEventFieldFacetsVariables } from './useUserAndEventFieldFacetsVariables';
import {
  UseFieldFacetsHookOutput,
  UseUserAndEventFieldFacetsHookInputs,
  UseUserAndEventFieldFacetsQueryData,
} from './types';
import { useMemoizedFacets } from './useMemoizedFacets';

export const useUserAndEventFieldFacets = ({
  dataType,
  field,
  enabled,
}: UseUserAndEventFieldFacetsHookInputs): UseFieldFacetsHookOutput => {
  const variables = useUserAndEventFieldFacetsVariables(dataType, field);
  const {
    data = [],
    isError: didError,
    isLoading,
  } = useRestPostQuery<UseUserAndEventFieldFacetsQueryData>(LIST_FIELD_FACETS, variables, {
    enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
  const fieldFacets = useMemoizedFacets(pick(data, 'term'));
  return { fieldFacets, isLoading, didError };
};
